import { render, staticRenderFns } from "./device-config.vue?vue&type=template&id=f25aceb8&scoped=true"
import script from "./device-config.vue?vue&type=script&lang=js"
export * from "./device-config.vue?vue&type=script&lang=js"
import style0 from "./device-config.vue?vue&type=style&index=0&id=f25aceb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25aceb8",
  null
  
)

export default component.exports